import { Hammer } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * A placeholder that says what it is.
 *
 * The sidebar shows the whole validated information architecture from day one, so these
 * routes exist before their screens do. Saying plainly "not built yet, it is chunk N" is
 * better than a blank page or a fake empty state — Ubi should be able to click around the
 * real shell and see exactly how much is real.
 */
export function NotBuiltYet({ what, chunk }: { what: string; chunk: string }) {
  return (
    <div className="px-4 py-16 lg:px-8">
      <div className="mx-auto max-w-md rounded-xl border border-dashed border-slate-300 bg-white px-6 py-12 text-center">
        <div className="mx-auto mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-slate-100 text-slate-400">
          <Hammer className="h-5 w-5" />
        </div>
        <h3 className="font-semibold text-slate-700">{what} is not built yet</h3>
        <p className="mt-2 text-sm text-slate-500">
          The screen is designed and validated — it arrives in {chunk}. The navigation is real so
          the shape of the product is reviewable now.
        </p>
        <Link
          to="/"
          className="mt-5 inline-block text-sm font-semibold text-brand-rose hover:underline"
        >
          Back to reports
        </Link>
      </div>
    </div>
  );
}
